/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OptimizeRouteResponse
 */
export interface OptimizeRouteResponse {
  /**
   *
   * @type {Array<string>}
   * @memberof OptimizeRouteResponse
   */
  orderedCompanyListItemIds: Array<string>;
  /**
   *
   * @type {number}
   * @memberof OptimizeRouteResponse
   */
  startLatitude?: number | null;
  /**
   *
   * @type {number}
   * @memberof OptimizeRouteResponse
   */
  startLongitude?: number | null;
}

/**
 * Check if a given object implements the OptimizeRouteResponse interface.
 */
export function instanceOfOptimizeRouteResponse(
  value: object,
): value is OptimizeRouteResponse {
  if (
    !("orderedCompanyListItemIds" in value) ||
    value["orderedCompanyListItemIds"] === undefined
  )
    return false;
  return true;
}

export function OptimizeRouteResponseFromJSON(
  json: any,
): OptimizeRouteResponse {
  return OptimizeRouteResponseFromJSONTyped(json, false);
}

export function OptimizeRouteResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OptimizeRouteResponse {
  if (json == null) {
    return json;
  }
  return {
    orderedCompanyListItemIds: json["orderedCompanyListItemIds"],
    startLatitude:
      json["startLatitude"] == null ? undefined : json["startLatitude"],
    startLongitude:
      json["startLongitude"] == null ? undefined : json["startLongitude"],
  };
}

export function OptimizeRouteResponseToJSON(json: any): OptimizeRouteResponse {
  return OptimizeRouteResponseToJSONTyped(json, false);
}

export function OptimizeRouteResponseToJSONTyped(
  value?: OptimizeRouteResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    orderedCompanyListItemIds: value["orderedCompanyListItemIds"],
    startLatitude: value["startLatitude"],
    startLongitude: value["startLongitude"],
  };
}
